import { appUrl } from "./app-origin.js";

const APP_LOCATIONS = {
  "Settings → Workspace → API Keys": "settings/workspace?tab=api-keys",
  "Workspace Settings": "settings/workspace?tab=api-keys",
  "Settings → Workspace": "settings/workspace",
  "Data Sources": "data-sources",
  "Command Center": "command-center",
  "Client Register": "register",
  "Report Builder": "builder",
  "Saved Reports": "saved-reports",
  "Invoice Defense": "invoice",
  "Project Forensics": "forensics",
  "AI Economics": "ai",
  "Sign in to the app": null,
};
const pattern =
  /Settings → Workspace → API Keys|Workspace Settings|Settings → Workspace|Data Sources|Command Center|Client Register|Report Builder|Saved Reports|Invoice Defense|Project Forensics|AI Economics|Sign in to the app|\b[A-Z][A-Z0-9]*_(?:[A-Z0-9]+_)*[A-Z0-9]+\b/gi;
const locations = Object.fromEntries(
  Object.entries(APP_LOCATIONS).map(([name, suffix]) => [name.toLowerCase(), suffix]),
);

// Locations use only the private controller's verified pair. Anonymous readers
// go to the real workspace picker, never a guessed/synthetic application URL.
export function documentationParts(text, selected) {
  const parts = [];
  let start = 0;
  for (const match of text.matchAll(pattern)) {
    const value = match[0];
    const isLocation = Object.hasOwn(locations, value.toLowerCase());
    if (!isLocation && value !== value.toUpperCase()) continue;
    if (match.index > start)
      parts.push({ type: "text", value: text.slice(start, match.index) });
    if (isLocation) {
      const suffix = locations[value.toLowerCase()];
      const href =
        suffix === null
          ? appUrl("/sign-in")
          : selected
            ? appUrl(
                `/org/${selected.organizationSlug}/workspace/${selected.workspaceSlug}/${suffix}`,
              )
            : appUrl("/workspaces");
      parts.push({
        type: "link",
        value,
        href,
        title:
          suffix !== null && !selected
            ? "Choose a workspace to open this application location."
            : undefined,
      });
    } else parts.push({ type: "inlineCode", value });
    start = match.index + value.length;
  }
  if (start < text.length)
    parts.push({ type: "text", value: text.slice(start) });
  return parts;
}

export function remarkDocumentationSemantics({ selected } = {}) {
  return (tree) => {
    const visit = (parent) => {
      if (!parent.children || ["code", "inlineCode"].includes(parent.type))
        return;
      parent.children = parent.children.flatMap((child) => {
        if (child.type !== "text") {
          visit(child);
          return [child];
        }
        return documentationParts(child.value, selected).map((part) =>
          part.type === "link"
            ? ["link", "linkReference"].includes(parent.type)
              ? { type: "text", value: part.value }
              : {
                  type: "link",
                  url: part.href,
                  title: part.title,
                  data: {
                    hProperties: {
                      className: ["ph-no-capture", "ph-no-record"],
                    },
                  },
                  children: [{ type: "text", value: part.value }],
                }
            : { type: part.type, value: part.value },
        );
      });
    };
    visit(tree);
  };
}

export function referenceDescription(markdown, selected) {
  // Preserve preexisting fenced/inline code and links. Transform only prose;
  // this presentation never changes the canonical downloaded specification.
  return markdown
    .split(/(```[\s\S]*?```|`[^`]*`|\[[^\]]*\]\([^)]*\))/g)
    .map((part, index) =>
      index % 2
        ? part
        : documentationParts(part, selected)
            .map((item) =>
              item.type === "link"
                ? `[${item.value}](${item.href})`
                : item.type === "inlineCode"
                  ? "`" + item.value + "`"
                  : item.value,
            )
            .join(""),
    )
    .join("");
}
